<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/Student Exam-Wise Question</span>
        </v-row>
        <br />
        <div style="border: 2px solid #2c85ad;">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <center class="heading">
                <h3>Student Exam Wise Question</h3>
            </center>
            <div class="box">
                <v-form ref="form">
                    <v-row style="justify-content: center;">
                        <v-col xs="12" sm="12" lg="4" md="6" cols="12">
                            <label class="bold">Exam</label>
                            <v-autocomplete
                                placeholder="Select Exam"
                                :items="exam_list"
                                item-text="name"
                                item-value="id"
                                persistent-hint
                                return-object
                                outlined
                                dense
                                class="select"
                                :rules="[v => !!v || 'required']"
                                v-model="selected_exam"
                                @change="getExamStudent()"
                            ></v-autocomplete>
                        </v-col>
                        <v-col xs="12" sm="12" lg="4" md="6" cols="12">
                            <label class="bold">Student</label>
                            <v-autocomplete
                                placeholder="Select Student"
                                :items="learner_list"
                                item-text="name"
                                item-value="learner_id"
                                persistent-hint
                                return-object
                                outlined
                                dense
                                class="select"
                                :rules="[v => !!v || 'required']"
                                v-model="selected_student"
                                :disabled="selected_exam == null"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-btn class="mb-2 button btn" @click="fetchdata()">Fetch</v-btn>
                    </v-row>
                </v-form>
            </div>
            <span v-if="question_answer_list.length > 0">
                <v-data-table :headers="headers" :items="question_answer_list" class="elevation-1 nowrap" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <download-excel class="mar" :data="question_answer_list" :fields="export_table_headers" worksheet="question_answer_list" name="QUESTION.xls">
                                <v-btn color="success" dark class="mb-2"> Export<v-icon dark>mdi-file-excel</v-icon> </v-btn>
                            </download-excel>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field>
                        </v-toolbar>
                    </template>
                </v-data-table>
            </span>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            exam_list: [],
            learner_list: [],
            question_answer_list: [],
            selected_exam: null,
            selected_student: null,
            overlay: false,
            headers: [
                { text: "Registration No.", value: "gr_no" },
                { text: "Student Name", value: "name" },
                { text: "Question Id", value: "qa_id" },
                { text: "Obtained Marks", value: "obtained_marks" },
                { text: "Weightage", value: "weightage" },
                { text: "Course", value: "course" },
            ],
            export_table_headers: {
                "Registration No.": "gr_no",
                "Student Name": "name",
                "Question Id.": "qa_id",
                "Obtained Marks": "obtained_marks",
                Weightage: "weightage",
                Course: "course",
            },
        }),
        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                this.overlay = true;
                axios
                    .post("/StudExamQueData/getExamList")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.exam_list = res.data.exam_list;
                            this.overlay = false;
                        } else {
                        }
                    })
                    .catch((error) => {});
            },
            getExamStudent() {
                if (this.selected_exam == null) {
                    this.showSnackbar("#b71c1c", "Please select Exam!");
                    return;
                } else {
                    this.overlay = true;
                    const data = {
                        exam_id: this.selected_exam.id,
                    };
                    axios
                        .post("/StudExamQueData/getExamStudentList", data)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.learner_list = res.data.learner_list;
                                this.overlay = false;
                            } else {
                            }
                        })
                        .catch((error) => {});
                }
            },
            fetchdata() {
                if (this.selected_exam == null) {
                    this.showSnackbar("#b71c1c", "Please select Exam!");
                    return;
                }
                if (this.selected_student == null) {
                    this.showSnackbar("#b71c1c", "Please select Student!");
                    return;
                } else {
                    this.overlay = false;
                    const data = {
                        exam_id: this.selected_exam.id,
                        learner_id: this.selected_student.learner_id,
                    };
                    axios
                        .post("/StudExamQueData/getExamStudentQuestionList", data)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.question_answer_list = res.data.question_answer_list;
                                this.overlay = false;
                            } else {
                            }
                        })
                        .catch((error) => {});
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
